import * as CrossPlatform from '../services/crossPlatform/crossPlatformService';
import { API_BACKOFFICE } from '../services/api/apiConst';
import { BACKEND_URL } from '../config_module';
import { getLogger } from '../services/logger';

// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

// ******************** MAIN ***************************

const debug = getLogger('service-worker:register-sw');

if (navigator.storage && navigator.storage.persist) {
  navigator.storage.persist().then(function(persistent) {
    if (!persistent) {
      debug('Storage will not be cleared except by explicit user action');
    }
  });
}

// ******************** MAIN ***************************

// ******************** API ***************************

export default function register() {
  if (process.env.NODE_ENV === 'production' && CrossPlatform.isElectronApp() && 'serviceWorker' in navigator) {
    let paramsEncoded = getConfiguration();
    let swReg;
    window.addEventListener('load', () => {
      let swUrl = `${process.env.PUBLIC_URL}/service-worker.js?${paramsEncoded}`;

      if (!navigator.serviceWorker.controller) {
        window.location.reload();
      }

      navigator.serviceWorker
        .register(swUrl)
        .then(registration => {
          swReg = registration;

          clearSwPrecache();

          addLifecycleListeners(registration);
        })
        .catch(error => {
          debug.error('Error during service worker registration: %s', error);
          try {
            swReg.unregister();
          } catch (err) {
            debug.error('Could not un-register sw: %s', err);
          }
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}

// ******************** API ***************************

// ****************** HELPERS *************************

function getConfiguration() {
  let params = {
    isElectron: CrossPlatform.isElectronApp(),
    backendUrl: BACKEND_URL,
    cmsOrigin: parseUrl(API_BACKOFFICE).origin
  };
  let paramsEncoded = Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
  return paramsEncoded;
}

function addLifecycleListeners(registration) {
  registration.onupdatefound = () => {
    const installingWorker = registration.installing;
    installingWorker.onstatechange = () => {
      debug('SW state: %s', installingWorker.state);

      if (installingWorker.state === 'installed') {
        if (navigator.serviceWorker.controller) {
          debug('New content is available; please refresh.');
        } else {
          debug('Content is cached for offline use.');
        }
      }
    };
  };
}

function parseUrl(url) {
  // eslint-disable-next-line no-useless-escape
  const urlParts = /^((?:\w+\:\/\/[^\/]+))(.*)$/.exec(url);
  return {
    origin: urlParts[1],
    path: urlParts[2]
  };
}

function clearSwPrecache() {
  const CACHE_SW_PRECACHE_BASE = 'sw-precache';
  const INDEX_HTML_BASE = 'index.html?_sw-precache';

  return caches.keys().then(function(cacheNames) {
    cacheNames.map(function(cacheName) {
      const isPrecache = cacheName.indexOf(CACHE_SW_PRECACHE_BASE) > -1;
      if (!isPrecache) return null;

      return caches.open(cacheName).then(precache => {
        return precache.keys().then(precachedRequests => {
          precachedRequests.map(function(precachedRequest) {
            const isIndexHtml = precachedRequest.url.indexOf(INDEX_HTML_BASE) > -1;
            if (!isIndexHtml) return null;

            console.log('Cleaning index.html from sw-precache ' + cacheName + '...');
            return precache.delete(precachedRequest.url);
          });
        });
      });
    });
  });
}

// ****************** HELPERS *************************
